import createReducer from '../helpers/CreateReducer';
import { StaticFilesConstants } from '../constants/actions';

interface StaticFilesState {
  helpContent: null | string;
  maintenanceContent?: null | string;
  noPersistance: boolean;
}

export const getInitialState = (): StaticFilesState => ({
  helpContent: null,
  noPersistance: true
});

export default createReducer(getInitialState, {
  [`${StaticFilesConstants.LOAD_MAINTENANCE_CONTENT}_SUCCESS`]: (
    state: StaticFilesState,
    { content }
  ) => ({
    ...state,
    maintenanceContent: content
  }),
  [`${StaticFilesConstants.LOAD_MAINTENANCE_CONTENT}_FAILURE`]: (
    state: StaticFilesState
  ) => ({
    ...state,
    maintenanceContent: null
  })
});
